module.exports = __webpack_public_path__ + "img/book2-active.b6a4b763.png";